@let seasonValue = season();
@let symbolsValue = symbols();
@if (seasonValue === 'winter') {
  <div [className]="classes['freezingRain']" align="center">
    <br />
    {{ translationGroup + 'freezingRain' | translate }}
    <br />
    @if (symbolsValue['freezingRain'] === 'check') {
      <span>
        <fa-icon [icon]="['far', 'check']" size="2x"> </fa-icon>
      </span>
    }
    @if (symbolsValue['freezingRain'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <div [className]="classes['snow']" align="center">
    <br />
    {{ translationGroup + 'snow' | translate }}
    <br />
    @if (symbolsValue['snow'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['snow'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <br />
  <div [className]="classes['freezingWet']" align="center">
    <br />
    {{ translationGroup + 'freezingWet' | translate }}
    <br />
    @if (symbolsValue['freezingWet'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['freezingWet'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <div [className]="classes['rime']" align="center">
    <br />
    {{ translationGroup + 'rime' | translate }}
    <br />
    @if (symbolsValue['rime'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['rime'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
} @else if (seasonValue === 'summer') {
  <div [className]="classes['rime']" align="center">
    <br />
    {{ translationGroup + 'rime' | translate }}
    <br />
    @if (symbolsValue['rime'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['rime'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <div [className]="classes['freezingWet']" align="center">
    <br />
    {{ translationGroup + 'freezingWet' | translate }}
    <br />
    @if (symbolsValue['freezingWet'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['freezingWet'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <br />
  <div [className]="classes['snow']" align="center">
    <br />
    {{ translationGroup + 'snow' | translate }}
    <br />
    @if (symbolsValue['snow'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['snow'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
  <div [className]="classes['freezingRain']" align="center">
    <br />
    {{ translationGroup + 'freezingRain' | translate }}
    <br />
    @if (symbolsValue['freezingRain'] === 'check') {
      <span><fa-icon [icon]="['far', 'check']" size="2x"></fa-icon></span>
    }
    @if (symbolsValue['freezingRain'] === 'minus') {
      <span><fa-icon [icon]="['far', 'minus']" size="2x"></fa-icon></span>
    }
  </div>
}
